/* tslint:disable */
/* eslint-disable */
/**
 * Gallaudet
 * A set of APIs to allow seamless integration of the NUSA Roblox game
with Google Classrooms.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated.
 * Do not edit the class manually.
 */
import { exists, mapValues } from './model-utils';

/**
 * 
 * @export
 * @interface PutExperienceResponseContent
 */
export interface PutExperienceResponseContent {
    /**
     * 
     * @type {string}
     * @memberof PutExperienceResponseContent
     */
    message?: string;
}


/**
 * Check if a given object implements the PutExperienceResponseContent interface.
 */
export function instanceOfPutExperienceResponseContent(value: object): boolean {
    let isInstance = true;
    return isInstance;
}

export function PutExperienceResponseContentFromJSON(json: any): PutExperienceResponseContent {
    return PutExperienceResponseContentFromJSONTyped(json, false);
}

export function PutExperienceResponseContentFromJSONTyped(json: any, ignoreDiscriminator: boolean): PutExperienceResponseContent {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {

        'message': !exists(json, 'message') ? undefined : json['message'],
    };
}

export function PutExperienceResponseContentToJSON(value?: PutExperienceResponseContent | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {

        'message': value.message,
    };
}

